import { Fragment } from "react/jsx-runtime";
import { Box, Toolbar } from "@mui/material";
import { Outlet, useParams } from "react-router";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/de';
import { Title } from "./decoration/Title";
import {  drawerWidth } from "./decoration/SideMenu";
import SideMenu from "./decoration/SideMenu";
import { styled } from '@mui/material/styles';
import * as React from "react";
import { useFetchTournamentQuery } from "../store/tournament/TournamentApi";


/*
Main arbeitet hier mit einem Verschiebemechanismus, der die Größe
des darzustellenden Bereichs dem geöffneten oder geschlossenem 
Seitenmenü anpasst. Hierdurch verändert sich nach dem Schließen
auch der Bereich, der die Darstellung ermöglicht. 
*/

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    variants: [
      {
        props: ({ open }) => open,
        style: {
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          marginLeft: 0,
        },
      },
    ],
  }),
);


export default function Frame()
{  

  // Ermitteln des aktuellen Jahres
  const {year} = useParams();

  // die aktuellen Turnierdaten immer schön cachen: 
  useFetchTournamentQuery(year);

  // Das Seitenmenü wird durch diesen Strang hier weiter berücksichtigt
  const [isSideMenuOpen, setSideMenuOpen] = React.useState(false);

  return(
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">  
      <div>
        { /* Allgemeiner Aufbau für den Bildschirm */ }
        <Box sx={{ display: 'flex' }}>         
          <Fragment>             
            <Title 
              isSideMenuOpen={isSideMenuOpen} 
              onSideMenuToggle={() => setSideMenuOpen(!isSideMenuOpen)} 
            />                   
          </Fragment>
          <SideMenu 
            // mittels 'key' erzwingen wir bei einem Jahreswechsel
            // auch das Neuladen des Frames...
            key={year}
            isSideMenuOpen={isSideMenuOpen} 
            onSideMenuToggle={() => setSideMenuOpen(!isSideMenuOpen)}
          />
          <Main open={isSideMenuOpen}>
            <Toolbar />
            <Outlet />
          </Main>
        </Box>
      </div>
    </LocalizationProvider>
  );
};